import mainStyle from "./Main.module.css";

import { useState } from "react";
import { Outlet } from "react-router-dom";
function Main({ fullWidth }) {
  return (
    <main
      className={mainStyle.main}
      id="main"
      style={{ maxWidth: fullWidth ? "100%" : "1200px" }}
    >
      <Outlet />
    </main>
  );
}

export default Main;
